import {
	StyledArrow,
	StyledInput,
	StyledInputArrowContainer,
	StyledSelectorContainer,
	StyledTextContainer,
} from './Selector.styled';

interface ISelectorProps {
	title: string;
	index: number;
	minIndex?: number;
	maxIndex: number;
	onChange?: (index: number) => void;
}

const Selector: React.FC<ISelectorProps> = ({
	title,
	index,
	minIndex = 0,
	maxIndex,
	onChange,
}) => {
	const handlePrevClick = () => {
		const newValue = Math.max(index - 1, minIndex);
		onChange?.(newValue);
	};

	const handleNextClick = () => {
		const newValue = Math.min(index + 1, maxIndex);
		onChange?.(newValue);
	};

	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const cleanedValue = e.target.value.replace(/\D/g, '');
		const newValue =
			cleanedValue === '' ? minIndex : parseInt(cleanedValue, 10);

		if (!isNaN(newValue)) {
			const clampedValue = Math.min(Math.max(newValue, minIndex), maxIndex);
			onChange?.(clampedValue);
		}
	};

	return (
		<StyledSelectorContainer>
			<StyledTextContainer>
				<span>{title}</span>
				<span>
					{index}/{maxIndex}
				</span>
			</StyledTextContainer>
			<StyledInputArrowContainer>
				<StyledArrow $direction={'left'} onClick={handlePrevClick} />
				<StyledInput value={index.toString()} onChange={handleInputChange} />
				<StyledArrow $direction={'right'} onClick={handleNextClick} />
			</StyledInputArrowContainer>
		</StyledSelectorContainer>
	);
};

export { Selector };
